import React from "react"
import { Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"

import CommonChangePassword from "./CommonChangePassword"
import { useTranslation } from "react-i18next"

const ChangePassword = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  document.title = t("Change Password ")

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs />

        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <CardTitle className="mb-4">{t("Change Password")}</CardTitle>
                <CommonChangePassword t={t} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default ChangePassword
